export const SIZE_FILTER_ID = 'size';
export const COLOR_FILTER_ID = 'color';
export const PRICE_FILTER_ID = 'price';
// Включает в себя "delivery_wo_exp,exp_delivery"
export const DELIVERY_FILTER_ID = 'delivery';
// Доставка, без экспресс
export const DELIVERY_WO_EXP_FILTER_ID = 'delivery_wo_exp';
export const PICKUP_FILTER_ID = 'pickup';
// Так как от ProductGate приходит 'exp_delivery' используем его
// В фильтрах меняем 'express_delivery' -> 'exp_delivery' так же и в $api.getDeliveryTerms() | delivery-terms.js
export const EXP_DELIVERY_FILTER_ID = 'exp_delivery';

export const SORT_PARAM_ID = 'sortType';

export const UNALLOCATED_GROUP = 'unallocated';
export const SOLDOUT_GROUP = 'soldout';

export const PRICE_ASC = 'BY_PRICE_ASC';
export const PRICE_ASC_NAME = 'По возрастанию цены';
export const PRICE_DESC = 'BY_PRICE_DESC';
export const PRICE_DESC_NAME = 'По убыванию цены';
export const POPULARITY = 'BY_POPULARITY';
export const POPULARITY_NAME = 'По популярности';
export const NEWEST_FIRST = 'NEWEST_FIRST';
export const NEWEST_FIRST_NAME = 'По новизне';
export const DISCOUNT_DESC = 'BY_DISCOUNT_DESC';
export const DISCOUNT_DESC_NAME = 'По скидке';

export const SORT_NAME_MAP = {
  [NEWEST_FIRST]: NEWEST_FIRST_NAME,
  [PRICE_ASC]: PRICE_ASC_NAME,
  [PRICE_DESC]: PRICE_DESC_NAME,
  [DISCOUNT_DESC]: DISCOUNT_DESC_NAME,
  [POPULARITY]: POPULARITY_NAME,
};

export const DEFAULT_SORT = NEWEST_FIRST;

